var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { cloneDeep, isEmpty, isEqual, pick } from "lodash-es";
const debounceOptions = ['leading', 'trailing'];
const debounceOptionObj = [{
  label: '先执行',
  value: 'leading'
}, {
  label: '后执行',
  value: 'trailing'
}];
const defaultConfig = {
  wait: 200,
  type: 'close',
  leading: true
};
let DebounceConfig = class DebounceConfig extends Vue {
  constructor() {
    super(...arguments);
    this.temp = cloneDeep(defaultConfig);
  }
  created() {
    this.$watch('value', val => {
      if (val) {
        this.$set(this, 'temp', {
          ...defaultConfig,
          ...val
        });
      } else {
        const v = {
          ...cloneDeep(defaultConfig),
          ...pick(this.temp, ['type', 'wait'])
        };
        this.$set(this, 'temp', v);
      }
    }, {
      immediate: true,
      deep: true
    });
    this.$watch('temp', val => {
      if (val.type === 'close') {
        this.$emit('change', undefined);
      } else if (!isEmpty(val) && !isEqual(val, this.value)) {
        const emitValue = cloneDeep(val);
        if (!emitValue.type) {
          emitValue.type = 'debounce';
        }
        if (emitValue.wait) {
          emitValue.wait = parseInt(`${emitValue.wait}`, 10);
        }
        this.$emit('change', emitValue);
      }
    }, {
      deep: true
    });
  }
  get checkBoxValue() {
    return Object.keys(this.temp).filter(key => debounceOptions.includes(key) && this.temp[key]);
  }
  handleCheckboxChange(val) {
    if (val.length === 0) {
      debounceOptions.forEach(key => {
        this.$set(this.temp, key, !this.value[key]);
      });
    } else {
      debounceOptions.forEach(key => {
        this.$set(this.temp, key, val.includes(key));
      });
    }
  }
  render() {
    const h = arguments[0];
    const disable = this.temp.type === 'close';
    return h("div", {
      "style": 'display: inline-flex;flex-wrap: nowrap;white-space: nowrap;gap:16px;align-items: center;'
    }, [h("a-radio-group", {
      "attrs": {
        "size": 'small',
        "default-value": 'close',
        "button-style": 'solid'
      },
      "model": {
        value: this.temp.type,
        callback: $$v => {
          this.$set(this.temp, "type", $$v);
        }
      }
    }, [h("a-radio-button", {
      "attrs": {
        "value": 'close'
      }
    }, ["\u5173\u95ED"]), h("a-radio-button", {
      "attrs": {
        "value": 'debounce'
      }
    }, ["\u9632\u6296"]), h("a-radio-button", {
      "attrs": {
        "value": 'throttle'
      }
    }, ["\u8282\u6D41"])]), h("a-input", {
      "attrs": {
        "disabled": disable,
        "size": 'small',
        "suffix": 'ms'
      },
      "style": 'width:80px',
      "model": {
        value: this.temp.wait,
        callback: $$v => {
          this.$set(this.temp, "wait", $$v);
        }
      }
    }), h("a-checkbox-group", {
      "attrs": {
        "disabled": disable,
        "value": this.checkBoxValue,
        "options": debounceOptionObj
      },
      "on": {
        "change": this.handleCheckboxChange
      }
    })]);
  }
};
DebounceConfig = __decorate([Component({
  name: 'DebounceConfig',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    }
  }
})], DebounceConfig);
export default DebounceConfig;
//# sourceMappingURL=DecounceConfig.js.map
